import React from 'react';
import PrimaryButton from '../../button/PrimaryButton';
import SecondaryButton from '../../button/SecondaryButton';
import './FormActions.css';

/**
 * FormActions Component
 * Button group for form actions (submit, cancel, etc.)
 * 
 * @param {string} primaryLabel - Primary button label (e.g., "Submit")
 * @param {string} secondaryLabel - Secondary button label (e.g., "Cancel")
 * @param {function} onPrimary - Primary button click handler: () => void
 * @param {function} onSecondary - Secondary button click handler: () => void
 * @param {boolean} primaryDisabled - Primary button disabled state
 * @param {boolean} secondaryDisabled - Secondary button disabled state
 * @param {string} className - Additional CSS classes
 */
const FormActions = ({
  primaryLabel,
  secondaryLabel,
  onPrimary,
  onSecondary,
  primaryDisabled = false,
  secondaryDisabled = false,
  className = ''
}) => {
  return (
    <div className={`form-actions ${className}`.trim()}>
      {secondaryLabel && onSecondary && (
        <SecondaryButton
          onClick={onSecondary}
          disabled={secondaryDisabled}
        >
          {secondaryLabel}
        </SecondaryButton>
      )}
      {primaryLabel && onPrimary && (
        <PrimaryButton
          onClick={onPrimary}
          disabled={primaryDisabled}
        >
          {primaryLabel}
        </PrimaryButton>
      )}
    </div>
  );
};

export default FormActions;

